import "./Results.css";

import React, {memo, useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons';

import {CommonAttribute} from "features/validationRules/types";

const AttributeComponent = ({attribute: {attribute, common_for}, docsSet}: { docsSet: string[], attribute: CommonAttribute }) => {
    const [extended, setExtended] = useState<boolean>(false);

    return (
        <div className={"res-wrapper"}>
            <div className="res-container" onClick={() => {setExtended(!extended)}}>
                <p className="res-name">{attribute}{extended? "" :" (common for "+common_for.length+"/"+docsSet.length+" docs)"}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={extended? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div className="extendable-res-container" style={{display: extended? "flex" : "none"}}>
                {common_for.map(link => <a key={link} className="extendable-res-container-content" target="_blank" rel="noreferrer" href={link}>{link.split('&')[1].split('=')[1]}</a>)}
                {docsSet.length > common_for.length? <p className="absent-in-message">Absent in:</p> : <></>}
                {docsSet.filter(doc => !common_for.includes(doc)).map(link => <a key={link} className="extendable-res-container-content missed-file" target="_blank" rel="noreferrer" href={link}>{link.split('&')[1].split('=')[1]}</a>)}
            </div>
        </div>
    );
}

export default memo(AttributeComponent);